import { ExtendedConstructionNumber } from '../../api-utilities/api-utilities.types';

const getApartmentBuildingView = (constructionNumber: ExtendedConstructionNumber) =>
    constructionNumber.apartmentBuilding?.views?.find((s) =>
        s.pointers?.find((s) => s.constructionNumberId === constructionNumber.id),
    );

const getApartmentBuildingViewById = (constructionNumber: ExtendedConstructionNumber, id: string) =>
    constructionNumber.apartmentBuilding?.views?.find((view) => view.id === id);

export { getApartmentBuildingView, getApartmentBuildingViewById };
